export class Accommodation {
    name: string;
    badge: string;
    description: string;
    type: string;
    Location: Location;
    cityId: number;
    localId: string;
    childrenPolicy: string;
    facilities: string[];
    RoomTypes: [];
    AccommodationPictures: [];
    included: [];

    constructor() {
        this.name = '';
        this.badge = '';
        this.description = '';
        this.type = '';
        this.cityId = null;
        this.localId = '';
        this.Location = null;
        this.childrenPolicy = '';
        this.facilities = [];
        this.RoomTypes = [];
        this.AccommodationPictures = [];
        this.included = [];
    }
}
